// @ts-nocheck
import { GetTrailerTrackingsV2ApiParameter } from "@store/Framework/Services/TrailerServiceV2";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<GetTrailerTrackingsV2ApiParameter>;

export const DispatchUpdateParameter: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/TrailerTrackingV2/UpdateParameter",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateParameter];

const updateParameter = createHandlerChainRunner(chain, "UpdateParameter");
export default updateParameter;
